// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gI","title":"hI","rewardsStars":"iI"};